<template>
    <div>
        <div class="row form-group">
            <div class="col-sm-5 text-right">
                <label>ยอดเงินรับเข้า <span style="font-weight: bold">(เดดิต)</span></label>
            </div>
            <div class="col-sm-6">
                <input class="form-control" v-model="form.debit"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-sm-5 text-right">
                <label>ยอดเงินรับออก <span style="font-weight: bold">(เครดิต)</span></label>
            </div>
            <div class="col-sm-6">
                <input class="form-control" v-model="form.credit"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-sm-5 text-right">
                <label>วันที่</label>
            </div>
            <div class="col-sm-6">
                <date-picker
                    v-model="form.date"
                    type="date"
                    :format="changeFormat"
                    :lang="lang"
                    confirm
                    placeholder="วันที่นำเข้า">
                </date-picker>
            </div>
        </div>
        <div class="col text-center">
            <button class="btn btn-success" @click="cashToDebit">
                <icon name="save" style="width: 25px"></icon>
                บันทึก
            </button> &nbsp;&nbsp;
            <button class="btn btn-outline-secondary" @click="cancel">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import moment from "moment";

export default {
    props: {form: null},
    components: {
        DatePicker
    },
    name: "statement-modal",
    created() {
        this.$store.dispatch("TransactionType/setTransactionTypes");
    },
    computed: {
        ...mapState({
            cash_type: state => {
                return state.TransactionType.transactionTypes.filter(data => data.id == 3);
            },
            statement: state => {
                return state.Bank.statement_data;
            }
        }),
    },
    data() {
        return {
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    methods: {
        cashToDebit() {
            if (this.form.credit && this.form.debit) {
                alert('เลือกบันทึกเครดิตหรือเดบิตอย่างใดอย่างหนึ่ง');
            } else if (!this.form.credit && !this.form.debit) {
                alert('เลือกบันทึกเครดิตหรือเดบิตอย่างใดอย่างหนึ่ง');
            } else {
                if (this.cash_type.length > 0) {
                    this.form.transaction_type = this.cash_type[0];
                }
                if (!this.form.date) {
                    this.form.date = moment().format("YYYY-MM-DD");
                }
                this.form.date = moment(this.form.date).format("YYYY-MM-DD");

                // this.statement.dc.push(this.form);
                // this.statement.dc = _.orderBy(this.statement.dc, ['date'], ['asc']);
                this.$emit("submit", this.form);
            }
        },
        cancel() {
            this.$emit("submit", false);
        }

    }
}
</script>

<style scoped>

</style>
